import React, {useState} from "react";
import {useForm} from "react-hook-form";
import AdminFields from "./AdminFields";
import EditAdminFields from "./EditAdminFields";

export default function () {
  const {register, handleSubmit, reset, control} = useForm();
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({});
  const adminFields = <AdminFields {...{register, control, data, errors}} />;
  const editAdminFields = <EditAdminFields {...{register, control, data, errors}} />;

  return {
    setErrors,
    adminFields,
    editAdminFields,
    handleSubmit,
    setData,
    reset,
  }
}